import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler'; // For temporal popups
import useTranslations from '@/i18n/useTranslations';
import AuthService from '@/services/auth.service';
import Text from '@/shared-components/text/components/Text';

import './styles/ForgotPassword.css';

export default function ForgotPassword({ userEmail }) {
  const [loading, setLoading] = useState(false);
  const t = useTranslations('common.user_settings.login.forgot_password');
  const { stateHandler } = useStateHandler();

  async function forgotPassword() {
    setLoading(true);

    const { response } = await AuthService.requestResetPassword(userEmail);

    if (response.ok) {
      setLoading(false);
      stateHandler.set("temporalPopup", { 
        text: t('request_sent')
      });
    } else {
      setLoading(false);
    }
  }

  return (
    <div className={`settings-forgot-password__container ${loading ? "disabled" : ""}`}>
      <Text
        className="settings-forgot-password__button element-non-selectable font-size-medium"
        onClick={forgotPassword}>
        {t('button')}
      </Text>
      {/* Spinner removed, so no loading indicator is displayed now */}
    </div>
  );
}
